import jwt from "jwt-decode";

class useToken{
    getUser() {
        const tokenString = localStorage.getItem('token');
        if (tokenString) {
            return jwt(tokenString);
        }

    };
    verifyExpToken(){
        if (localStorage.getItem('token')) {
            const now = Math.floor(Date.now()/1000);
            const user = this.getUser();
            if (now > user.exp) {
                return false
            }
            else{
                return true
            }
        }
        else{
            return false
        }
    };
    verifyToken(){
        if (localStorage.getItem('token')) {
            const user = this.getUser()
            return user.folio !== '';
        }
        else{
            return false
        }
    };
    getDatos(){
        const datos = localStorage.getItem('datos');
        if (datos) {
            return JSON.parse(datos);
        }
        else{
            return ''
        }
    };
    setToken(token, datos){
        localStorage.setItem("token", token);
        localStorage.setItem("datos", JSON.stringify(datos));

        window.dispatchEvent(new CustomEvent("token-updated"));
    };
    clearDatos() {
        localStorage.removeItem("datos");
        window.dispatchEvent(new CustomEvent("token-updated"));
    }
}
const u = new useToken();
export default u;